<template>
  <div>
    <div class="review-back-detail">
      <div class="review-stop-box">
        <h4>审阅流程</h4>
        <Steps direction="vertical">
          <van-radio-group v-model="node_id">
            <van-radio :name="node.id" v-for="(node, index) in returnNodes" :key="node.id">
              <Step
                :nodeClass="getCurNode() === index ? 'cur-node' : ''"
                hiddenStepsNum
              >
                <h5>{{node.name}}</h5>
                <div class="review-user-wrap">
                  <div class="review-user">
                    <div class="user-avatar" v-if="node.type === 1">
                      <avatar
                        :user="workflowInfo.author"
                        :size="30"
                        @click="userDetail(workflowInfo.author.id)"
                      />
                      <em class="pre-ellipsis">{{ workflowInfo.author.name }}</em>
                    </div>
                    <template v-for="(user, index) in node.approveUsers">
                      <div class="user-avatar"
                        v-if="node.type !== 1"
                        :key="index"
                      >
                        <avatar
                          :user="user.approveUser"
                          :size="30"
                          @click="userDetail(user.approveUser.id)"
                        />
                        <em class="pre-ellipsis">{{ user.approveUser.name }}</em>
                      </div>
                      <div class="user-right-icon" :key="user.approveUser.id" v-if="node.handleType === 0 && index !== node.approveUsers.length -1">
                        <img src="@/assets/embedAppPageImg/act_add.svg"/>
                      </div>
                      <div class="user-right-icon" :key="user.approveUser.id" v-if="node.handleType === 2 && index !== node.approveUsers.length -1">
                        <img src="@/assets/embedAppPageImg/page_arrow2.svg"/>
                      </div>
                    </template>
                  </div>
                </div>
              </Step>
            </van-radio>
          </van-radio-group>
        </Steps>
      </div>
      <div class="back-message">
        <message-card title="审批意见" isRequire>
          <van-field
            v-model="backMessage"
            placeholder="请填写审批意见（必填）"
            type="textarea"
          />
        </message-card>
      </div>
    </div>
    <workflow-form :nodeId="node_id" :backMessage="backMessage" :workflowInfo="this.$props.workflowInfo"/>
  </div>
</template>
<script>
import {i18n} from '@/utils/i18n'
import WorkflowForm from './WorkflowForm'
import Steps from '../components/Steps'
import Step from '../components/Step'
import Avatar from '../../utils/Avatar'
import { RadioGroup, Radio } from 'vant'
import MessageCard from '../components/MessageCard'
import { goToUserDetail } from '@/utils/common'

export default {
  name: 'WorkflowBack',
  i18n,
  components: {
    WorkflowForm,
    Steps,
    Step,
    Avatar,
    RadioGroup,
    Radio,
    MessageCard
  },
  props: {
    workflowInfo: Object,
    currentNodeIndex: Number
  },
  data () {
    return {
      curChecked: null,
      returnNodes: [],
      node_id: null,
      backMessage: ''
    }
  },
  watch: {
    $route (to, from) {
    }
  },
  created () {
    let nodeArr = [...this.$props.workflowInfo.nodes].slice(0, this.$props.currentNodeIndex)
    this.returnNodes = nodeArr
    document.title = '退回节点'
  },
  methods: {
    userDetail (id) {
      goToUserDetail(id)
    },
    getCurNode () {
      const { currentNodeId, nodes } = this.$props.workflowInfo
      let curr
      nodes.some((ele, index, arr) => {
        if (ele.id === currentNodeId) {
          curr = index
          return true
        }
      })
      return curr
    }
  }
}
</script>
<style lang="postcss">
@import 'variables';

.review-back-detail {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;

  & .review-stop-box {
    display: flex;
    background-color: #fff;
    flex-direction: column;
    padding: 16px;
    box-sizing: border-box;
    & h4 {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: var(--fontBasicColor);
      margin-bottom: 16px;
    }
    & .steps-wrap {
      &.is-vertical {
        & .van-radio-group {
          & .van-radio {
            & .user-right-icon {
              margin-right: 4px;
              margin-top: 12px;
              & img {
                width: 16px;
                height: 16px;
              }
            }
            &:first-child {
              & .van-radio__label {
                & .step-item {
                  &::before {
                    left: 8px;
                    background-color: transparent;
                  }
                }
              }
            }
            &:last-child {
              & .van-radio__label {
                & .step-item {
                  & .stop-left {
                    & .step-line {
                      background-color: transparent;
                    }
                  }
                }
              }
            }
          }
          & .van-radio__icon {
            display: flex;
            flex-direction: column;
            padding-top: 9px;
            height: 16px;
            position: absolute;
            line-height: 16px;
            z-index: 1;
            & .van-icon {
              width: 16px;
              height: 16px;
              background-color: #fff;
            }
            &.van-radio__icon--checked {
              & .van-icon {
                background-color: #1989fa;
              }
            }
          }
          & .van-radio__label {
            margin: 0;
            & .step-item {
              &:first-child {
                &::before {
                  left: 8px;
                  background-color: #9BA7BA;
                }
              }
              &:last-child {
                & .stop-left {
                  & .step-line {
                    background-color: #9BA7BA;
                    margin-left: 8px;
                  }
                }
              }
              & .stop-left {
                width: 16px;
              }
            }
          }
        }
      }
    }
  }
  & .back-message {
    margin-top: 12px;
  }
}

</style>
